module.exports = __webpack_public_path__ + "img/pointW.762cda48.svg";